import React from 'react'
import './NewsLetter.css'

const NewsLetter = () => {
    return (
        <section className="newsletter">
            <h1>Get Exclusive Offers on Your Email</h1>
            <p>Subscribe to our newsletter and stay updated</p>

            <form className="newsletter-form">
                <input
                    type="email"
                    placeholder="Enter your email"
                    required
                />
                <button type="submit">Subscribe</button>
            </form>
        </section>
    )
}

export default NewsLetter